import type { IUseCase } from '@/shared/contracts/use-case.contract';
import { ENDPOINT, type UserAddress, type UserAddressRequest } from '../../types/user-address';
import type { IHttpClient } from '@/shared/contracts/http-client.contract';
import { HttpMethod } from '@/shared/contracts/http-client.contract';

type UseCaseInput = UserAddressRequest;

type UseCaseOutput = UserAddress;

export class AddUserAddressUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    if (!input) {
      throw new Error('User address is required');
    }

    const response = await this.client.sendRequest<UseCaseOutput, UseCaseInput>({
      method: HttpMethod.POST,
      endpoint: ENDPOINT,
      body: input,
    });

    return response;
  }
}
